import { FunctionComponent, useCallback } from 'react'

import styled, { css } from 'styled-components'

import translate from '@i18n'
import useAuthentication from '@hooks/useAuthentication'
import useTracking from '@hooks/useTracking'
import { ctaLoginClickHandler } from '@widgets/UserProfile/tracking'
import PrimaryCTAButton from '@components/Buttons/PrimaryCTAButton'

const StyledWrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing16 },
      colors: { fillWeak },
    },
  }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${spacing16};

    background-color: ${fillWeak};
    box-sizing: border-box;
    width: 100%;
    border-radius: ${spacing16};
    padding: ${spacing16};
  `}
`

const StyledText = styled.span`
  ${({
    theme: {
      colors: { textDefault },
      typography: {
        bodycopy: {
          small2: { bundledCSS: small2BodycopyCSS },
        },
      },
    },
  }) => css`
    color: ${textDefault};
    ${small2BodycopyCSS};
  `}
`

const StyledPrimaryButton = styled(PrimaryCTAButton)`
  width: 100%;
`

const OnboardingMessage: FunctionComponent = () => {
  const { login } = useAuthentication()

  const handleLoginTrack = useTracking(ctaLoginClickHandler)
  const onLogin = useCallback(() => {
    handleLoginTrack()
    login({ prefix: 'DIR', loginCase: 'email_only' })
  }, [handleLoginTrack, login])

  return (
    <StyledWrapper>
      <StyledPrimaryButton onClick={onLogin}>
        {translate('userProfilePage.onboardingMessage.button')}
      </StyledPrimaryButton>
      <StyledText>{translate('userProfilePage.onboardingMessage')}</StyledText>
    </StyledWrapper>
  )
}
export default OnboardingMessage
